import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card px-6" }
const _hoisted_2 = { class: "pt-2 pb-4 px-6" }
const _hoisted_3 = { class: "pb-2 mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-bullet" }, null, -1)
const _hoisted_5 = { class: "pt-2 pb-4 px-6" }
const _hoisted_6 = { class: "pb-4 mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px bg-bullet" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTitle = _resolveComponent("HeaderTitle")!
  const _component_DetailItem = _resolveComponent("DetailItem")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderTitle, {
      title: _ctx.$t('platformsInfo.relates'),
      subtitle: 
        _ctx.$t('platformsInfo.total') +
        ' ' +
        _ctx.projects.length +
        ' ' +
        _ctx.$t('platformsInfo.relates') +
        ' ' +
        _ctx.$t('platformsInfo.participants')
      
    }, null, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("platformsInfo.platform")), 1),
      _createVNode(_component_DetailItem, {
        title: _ctx.platform.name,
        subtitle: _ctx.$t('platformsInfo.leadBy'),
        lead: _ctx.adminUser
      }, {
        left: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["title", "subtitle", "lead"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("platformsInfo.projects")), 1),
      (_ctx.projects)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.projects, (project, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.technologies, (tech, index) => {
                return (_openBlock(), _createBlock(_component_DetailItem, {
                  key: index,
                  title: project.name,
                  subtitle: tech.name,
                  class: "mb-2"
                }, {
                  left: _withCtx(() => [
                    _hoisted_7
                  ]),
                  right: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      class: "btn btn-sm btn-light",
                      to: {
                    name: project.name == 'API' ? 'amplication' : 'mindmap',
                    params: {
                      projectId:
                        project.name == 'API'
                          ? project.amplicationAppId
                          : project.id,
                    },
                  }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("platformsInfo.view")), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 2
                }, 1032, ["title", "subtitle"]))
              }), 128))
            ], 64))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}